import { NgModule, ErrorHandler, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../material.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Components
import { LoadingComponent } from './components/loading/loading.component';
import { ErreurComponent } from './components/erreur/erreur.component';
import { IndisponibleComponent } from './components/indisponible/indisponible.component';
import { PageNonAuthentifieComponent } from './components/page-non-authentifie/page-non-authentifie.component';
import { FeatureInactiveComponent } from './components/feature-inactive/feature-inactive.component';

// Services
import { BffCommunicationService, CustomErrorHandler, GestionErreurService } from './services/_index';

// Interceptors
import { CustomHttpInterceptor } from './interceptors/custom-http.interceptor';
import { MpmJwtHttpInterceptor } from './interceptors/mpm-jwt-http.interceptor';
import { ConseillerHttpInterceptor } from './interceptors/conseiller-http.interceptor';

import { SharedModule } from '../shared/shared.module';
import { ErreurCaisseNonEligibleComponent } from './components/erreur-caisse-non-eligible/erreur-caisse-non-eligible.component';
import { FeatureToggleService } from './services/feature-toggle.service';
import { AppConfigService } from '../app-config.service';
import { Auth0HttpHeadersInterceptor } from './interceptors/auth0-http-headers.interceptor';

export const COMPONENTS = [
  LoadingComponent,
  ErreurComponent,
  IndisponibleComponent,
  FeatureInactiveComponent,
  ErreurCaisseNonEligibleComponent,
  PageNonAuthentifieComponent
];

@NgModule({
  imports: [CommonModule, TranslateModule, SharedModule, MaterialModule],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        BffCommunicationService,
        FeatureToggleService,
        AppConfigService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Auth0HttpHeadersInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ConseillerHttpInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: CustomHttpInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MpmJwtHttpInterceptor,
          multi: true
        },
        {
          provide: ErrorHandler,
          useClass: CustomErrorHandler
        },
        GestionErreurService
      ]
    };
  }
}
